<div
  class="bd-drawer"
  data-id="drawer"
  [ngClass]="{
    'bd-drawer-regular-width': size === 'regular',
    'bd-drawer-small-width': size === 'small',
  }"
  bdNoScroll
>
  <ng-template *ngTemplateOutlet="template" />
</div>
